var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJcb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMinYMid meet",
    viewBox: "0 0 48 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "jcb") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,3.00001915 C0,1.34315432 1.33389258,1.67128345e-15 3.00261497,1.61152042e-15 L44.997385,1.0753459e-16 C46.6556835,4.81448757e-17 48,1.34731857 48,3.00001915 L48,26.9999809 C48,28.6568457 46.6661074,30 44.997385,30 L3.00261497,30 C1.34431651,30 0,28.6526814 0,26.9999809 L0,3.00001915 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "jcb"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-1-Copy-64"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#C5C5C8",
    strokeWidth: 1,
    d: "M0.5,3.00001915 L0.5,26.9999809 C0.5,28.3779877 1.62190743,29.5 3.00261497,29.5 L44.997385,29.5 C46.3861928,29.5 47.5,28.3844807 47.5,26.9999809 L47.5,3.00001915 C47.5,1.62201227 46.3780926,0.5 44.997385,0.5 L3.00261497,0.5 C1.61380716,0.5 0.5,1.61551926 0.5,3.00001915 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-113-+-Rectangle-113-Copy-+-Rectangle-113-Copy-2-Copy-Copy-Copy-Copy-Copy",
    transform: "translate(16.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.00585866 C0,0.898053512 0.887729645,0 2,0 L4,0 L4,11.9941413 C4,13.1019465 3.11227036,14 2,14 L0,14 L0,2.00585866 Z",
    id: "Rectangle-113",
    fill: "#005CAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,2.00585866 C6,0.898053512 6.88772964,0 8,0 L10,0 L10,11.9941413 C10,13.1019465 9.11227036,14 8,14 L6,14 L6,2.00585866 Z",
    id: "Rectangle-113-Copy",
    fill: "#D80032"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,2.00585866 C12,0.898053512 12.8877296,0 14,0 L16,0 L16,11.9941413 C16,13.1019465 15.1122704,14 14,14 L12,14 L12,2.00585866 Z",
    id: "Rectangle-113-Copy-2",
    fill: "#4BB126"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJcb);
export default __webpack_public_path__ + "static/media/JCB.51d933176bc8a5b94a6d3407e538ad5c.svg";
export { ForwardRef as ReactComponent };